import { Component, OnInit, OnDestroy } from "@angular/core";
// import { Basecomponent } from 'src/app/directives/basecomponent.directive';
// import { BaseService } from 'src/app/services/base.service';
import { FormGroup, FormControl, Validators } from "@angular/forms";
// import { DRTOConstants } from 'src/app/utils/drtoconstants';
import { MatDialog } from "@angular/material/dialog";
import { MatDialogRef } from "@angular/material/dialog";
import { ApiService } from "../../../providers/api.service";
import { Router } from "@angular/router";
import { CouponsComponent } from "../coupons/coupons.component";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { debounceTime } from "rxjs/operators";
import { SharedService } from "src/app/providers/shared.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
@Component({
  selector: "sm-add-discount",
  templateUrl: "./add-discount.component.html",
  styleUrls: ["./add-discount.component.scss"],
})
export class AddDiscountComponent implements OnInit, OnDestroy {
  home_status: any = sessionStorage.getItem("home_service_status");
  shop_status: any = sessionStorage.getItem("shop_service_status");
  virtual_status: any = sessionStorage.getItem("virtual_service_status");
  addDiscountForm: FormGroup;
  filteredList: any[] = [];

  formattedAddress: any = "";
  city: string = "";
  state: string = "";
  country: string = "";
  discountType: Boolean = false;
  entityHash: any = "";
  isMerchantSpecific: Boolean = false;
  isLocationSpecific: Boolean = false;
  isAllMerchant: Boolean = false;
  selectedMerchant: any = [];
  suggestedMerchant: any = [];
  isMerchantSelected: Boolean = false;
  entityList: any[] = [];
  objectoptions = [{ name: "angular" }, { name: "aise" }];

  private apiSubscription: Subscription = new Subscription();
  constructor(
    public dialog: MatDialogRef<AddDiscountComponent>,
    public mdialog: MatDialog,
    private loader: LoaderServiceService,
    private _apiservice: ApiService,
    private router: Router,
    private sharedService: SharedService
  ) {
    this.addDiscountForm = new FormGroup({
      merchantName: new FormControl(null),
      merchantHashId: new FormControl(null),
      title: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.required]),
      discountApplyType: new FormControl(null, [Validators.required]),
      coupon_type: new FormControl(null, [Validators.required]),
      couponApplyShopType: new FormControl(null),
      couponApplyHomeType: new FormControl(null),
      couponApplyVirtualType: new FormControl(null),
      discountType: new FormControl("0"),
      minimumCartValue: new FormControl(null, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      maximumDiscountAmount: new FormControl(null, [
        Validators.pattern("^[0-9]*$"),
      ]),
      maximumAccess: new FormControl(null),
      membership_use_limit: new FormControl(null, [
        Validators.pattern("^[0-9]*$"),
      ]),
      location: new FormControl(null),
      discountValue: new FormControl(null, [
        Validators.required,
        Validators.pattern("^[0-9]?((.[0-9]+)|([0-9]+(.[0-9]+)?))$"),
      ]),
      startDate: new FormControl(null, [Validators.required]),
      expiryDate: new FormControl(null, [Validators.required]),
    });

    this.addDiscountForm
      .get("merchantName")!
      .valueChanges.pipe(debounceTime(500))
      .subscribe((response) => {
        // console.log(response);
        if (response && response.length) {
          this.filterData(response);
        } else {
          this.filteredList = [];
        }
      });

    this._apiservice.getAllEntity();
  }

  filterData(enteredData: any) {
    this.filteredList = this.entityList.filter((item) => {
      return (
        item.entityName.toLowerCase().indexOf(enteredData.toLowerCase()) > -1
      );
    });
    console.log(this.filteredList);
  }

  ngOnInit(): void {
    this.addDiscountForm.value.discountType = "1";
    console.log(this.addDiscountForm.value.discountType);

    this.apiSubscription = this._apiservice.apiResult.subscribe((data) => {
      console.log(data);

      // this.isLoading = true;
      // console.log(data);
      // console.log(data.result);
      // console.log(data.result.length);
      if (data.responseType === SM_CONSTANTS.GET_COUPONS_LIST_RESULT) {
        console.log(data);
      }
      if (data.responseType === SM_CONSTANTS.CREATE_DISCOUNT_COUPON_RESULT) {
        if (data.result) {
          if (data.result.errorcode == 0) {
            this.dialog.close({ msg: "success" });
          } else if (data.result.errorcode == 1) {
            this.loader.showLoader = false;
            const dialogRef = this.mdialog.open(CustomConfirmDialogComponent, {
              width: "400px",
              data: {
                title: "Alert",
                message:
                  "'" +
                  this.ddata.coupon_code +
                  "'" +
                  " coupon could not be created as there exists another active coupon with the same code. Either deactivate or delete it and then try again.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          }
        }
      }
      if (data.responseType === SM_CONSTANTS.GET_ALL_ENTITY_DETAILS_RESULT) {
        console.log(data);

        // this.isLoading=false
        if (data.result && data.result != null) {
          this.entityList = [];
          // this.filteredList = data.result
          data.result.forEach((element: any) => {
            this.entityList.push(element);
          });
          console.log(this.entityList);

          //   this.couponData=[];
          //   if(data.result.length > 1){
          //      data.result.forEach((element: any) => {
          //     this.couponData.push(element);
          //     this.isLoading = false
          //   });
          //   }else {
          //       this.couponData = data.result
          //       this.isLoading= false
          //   }
          // }else{
          //   this.couponData = []
          //   this.isLoading = false
          // }
        } else {
          // this.entityList = []
        }
      }
    });
    console.log(this.entityList);

    // this._apiservice.getDiscountCouponsList();

    // this._apiservice.getBusinessList();
    // this._apiSubscription = this._apiservice.apiResult.subscribe(resData =>{
    //   if(resData.responseType === SM_CONSTANTS.GET_BUSINESS_LIST_RESULT){
    //     console.log(resData);
    //     // this.messageList = resData.result ? resData.result : [];
    //     // console.log( this.messageList);
    //     // this.messageList.forEach((item )=> {
    //     //   item.addressInfo = JSON.parse(item.addressInfo).address_line
    //     // })
    //     //     console.log( this.messageList);

    //   }
    // });

    // Track description edits
    this.addDiscountForm.get("description")!.valueChanges.subscribe(() => {
      // User touched description → stop auto updates until other fields change
      this.autoDescription = false;
    });

    // Track other fields only
    this.addDiscountForm.valueChanges.subscribe((val) => {
      if (!this.autoDescription) {
        // User has edited description → don’t overwrite yet
        this.autoDescription = true; // reset so NEXT non-description change regenerates
        return;
      }

      // If the change did not come from description → regenerate
      this.generateDescription();
    });
  }

  onClickName(hash: string) {
    this.entityHash = hash;
  }

  changeDiscType(event: any) {
    console.log(this.addDiscountForm.value.discountApplyType);
    if (event.target.value == "percent") {
      this.discountType = true;
    } else {
      this.discountType = false;
    }
  }
  ddata: any;
  saveDiscount() {
    console.log(this.addDiscountForm.value);
    console.log(this.formattedAddress);

    let data = {
      businessHashId: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH),
      start_date: this.formatDate1(this.addDiscountForm.value.startDate),
      end_date: this.formatDate1(this.addDiscountForm.value.expiryDate),
      home_service_status:
        this.addDiscountForm.value.couponApplyHomeType === true ? 1 : 0,
      shop_service_status:
        this.addDiscountForm.value.couponApplyShopType === true ? 1 : 0,
      virtual_service_status:
        this.addDiscountForm.value.couponApplyVirtualType === true ? 1 : 0,
      description: this.addDiscountForm.value.description,
      discountType:
        this.addDiscountForm.value.discountApplyType === "percent" ? 1 : 2,
      discountValue: +this.addDiscountForm.value.discountValue,
      coupon_type: this.addDiscountForm.value.coupon_type,
      locationSpecific: 0,
      city: this.city === "" ? null : this.city,
      state: this.state === "" ? null : this.state,
      country: this.country === "" ? null : this.country,
      coupon_code: this.addDiscountForm.value.title,
      minimum_cart_value: +this.addDiscountForm.value.minimumCartValue,
      max_discount:
        this.addDiscountForm.value.discountApplyType === "percent"
          ? +this.addDiscountForm.value.maximumDiscountAmount
          : null,
      no_of_time_access: this.addDiscountForm.value.maximumAccess,
      membership_use_limit: this.addDiscountForm.value.membership_use_limit,
      applicableType: 1,
    };

    // console.log(data);

    Object.keys(data).forEach((key) => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });

    console.log(data);
    this.ddata = data;
    this.loader.showLoader = true;
    this._apiservice.createAndUpdateCoupon(data);
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  clickCheckbox(event: any) {
    // console.log(event);
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router
      .navigateByUrl("coupons", { skipLocationChange: true })
      .then(() => {
        this.router.navigate([currentUrl]);
      });
  }
  changeCouponType(event: any) {
    console.log(event);

    if (event.target.value == "0") {
      this.isAllMerchant = true;
      this.selectedMerchant = [];
      this.isMerchantSpecific = false;
      this.isMerchantSelected = false;
      this.isLocationSpecific = false;
    } else if (event.target.value == "6") {
      this.isAllMerchant = true;
      this.selectedMerchant = [];
      this.isMerchantSpecific = false;
      this.isMerchantSelected = false;
      this.isLocationSpecific = true;
    } else if (event.target.value == "1") {
      this.isMerchantSpecific = true;
      this.isAllMerchant = false;
      this.isLocationSpecific = false;
    }
  }

  // changeLocationType(event:any){
  //   console.log(event);
  //   this.formattedAddress = ''
  //   if(event.target.value == 'all'){
  //     this.isLocationSpecific = false

  //   }else if(event.target.value == 'specific'){
  //     this.isLocationSpecific = true
  //   }
  // }

  getFriendSuggestion(text: any) {
    // console.log(text,this.userType);
    if (
      this.addDiscountForm.value.merchantName &&
      this.addDiscountForm.value.merchantName.trim()
    ) {
      // this.apiService.searchUserListByZoneId(this.userType,this.selectedZoneId,text,false);
      console.log("nothing");
    }
    console.log(this.suggestedMerchant);
  }
  addMerchant(item: any) {
    console.log(item);
    this.isMerchantSelected = true;
    this.addDiscountForm.get("merchantName")!.patchValue(null);
    this.selectedMerchant = item;
    this.suggestedMerchant = [];
  }
  public handleAddressChange(address: any) {
    // console.log(address.address_components);

    address.address_components.forEach((element: any) => {
      if (element.types[0] == "locality") {
        this.city = element.long_name;
      }
      if (element.types[0] == "administrative_area_level_1") {
        this.state = element.long_name;
      }
      if (element.types[0] == "country") {
        this.country = element.long_name;
      }
    });

    //  this.formattedAddress = address.formatted_address;
  }

  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }

  // DYNAMIC COUPON DESCRIPTION GENERATION
  autoDescription: boolean = true; // track if user edits manually
  businessName: string = localStorage.getItem(
    SM_CONSTANTS.CURRENT_ENTITY_NAME
  )!; // get this from API or session
  businessUrl: string = sessionStorage.getItem("cbu")!; // construct later
  currencyCode: string = sessionStorage.getItem("cbcc")!; // default INR, can change

  generateDescription() {
    const code = this.addDiscountForm.value.title || "COUPON";
    const discountType = this.addDiscountForm.value.discountApplyType;
    const discountValue = this.addDiscountForm.value.discountValue;
    const couponType =
      this.addDiscountForm.value.coupon_type == 2 ? "membership" : "booking";

    // Service applicability
    let applicable: string[] = [];
    if (this.addDiscountForm.value.couponApplyShopType) applicable.push("shop");
    if (this.addDiscountForm.value.couponApplyHomeType) applicable.push("home");
    if (this.addDiscountForm.value.couponApplyVirtualType)
      applicable.push("virtual");
    const applicableStr = applicable.join(", ");

    // Discount text
    let discountText = "";
    if (discountType === "percent") {
      discountText = `${discountValue}%`;
    } else {
      discountText = `${this.currencyCode}${(+discountValue).toFixed(2)}`;
    }

    // End date
    const endDate = this.addDiscountForm.value.expiryDate
      ? new Date(this.addDiscountForm.value.expiryDate).toLocaleDateString(
          "en-GB",
          {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }
        )
      : "";

    // Construct business URL
    const businessName = this.businessName || "Business";
    const businessUrl =
      this.businessUrl ||
      `https://market.lookzup.com/business/${businessName.replace(/\s+/g, "")}`;

    // CTA
    const cta =
      couponType === "membership"
        ? "apply for membership"
        : "book an appointment";

    // Final description
    const desc = `Use coupon code ${code} and get ${discountText} discount on ${applicableStr} ${couponType} in ${businessName}. The offer ends on ${endDate}. Open the below link to ${cta}.
${businessUrl}`;

    this.addDiscountForm
      .get("description")!
      .patchValue(desc, { emitEvent: false });
  }
}
